<template>
    <div class="gong">
      <van-nav-bar
      title="找工厂"
      fixed
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
        <div class="top">
            <img src="../../assets/pt/011.png" alt="">
            <!-- <div @click="goi" class="top-r">
                <img src="../../assets/pt/02.png" alt="">
            </div> -->
        </div>
          <div
        class="search"
      >
        <van-search
          placeholder="请输入"
          shape="round"
          v-model="value"
          @search="go"
          left-icon='none'
           show-action
        >
         <template #action>
    <div @click="go" class="se" ><van-icon name="search" /></div>
  </template>
        </van-search>
      </div>
        <div class="nav-wrap">
      <div
        v-show="!oopupFlag"
        class="nav"
        
      >
        <ul  id="navul">
          <!-- <li
            :class="{ active: statusNav == index }"
            v-for="(item, index) in nav"
            :key="index"
            :id="index"
            @click="addClass(index)"
          >
           
            <span> {{ item.name }}</span>
          </li> -->
           <li
            :class="{ active: statusNav == 0 }"   
            :id="0"
            @click="addClass(0)"
          >
            <span> 推荐工厂</span>
          </li>
         
           <li
            :class="{ active: statusNav == 1 }"           
            :id="1"
            @click="addClass(1)"
          > 
             <!-- <div
              class="hot"   
               v-show="$store.state.shopid!=3"          
            >
              <van-icon name="fire" />
            </div> -->
            <span> 油漆涂料</span>
          </li>
           <!-- <li
            class="aimg"           
            :id="8"
            @click="addClass(8)"
            v-show="[3].indexOf($store.state.shopid) !=-1"
          >
           <img src="../assets/s11/01.png" alt="">
          </li> -->
          <li
            :class="{ active: statusNav == 2 }"           
            :id="2"
            @click="addClass(2)"
          >
            <span> 粉料·加固剂</span>
          </li>
           <li
            :class="{ active: statusNav == 3 }"           
            :id="3"
            @click="addClass(3)"
          >
            <span>胶类</span>
          </li>
            <li
            :class="{ active: statusNav == 4 }"           
            :id="4"
            @click="addClass(4)"
          >
            <span>五金辅料</span>
          </li>
            <li
            :class="{ active: statusNav == 5 }"           
            :id="5"
            @click="addClass(5)"
          >
            <span>防水</span>
          </li>
           
            <li
            :class="{ active: statusNav == 6 }"           
            :id="6"
            @click="addClass(6)"
          >
            <span>劳保用品</span>
          </li>
        </ul>
      </div>
      <div
        v-show="oopupFlag"
        class="nav-wrap-all"
      >全部分类</div>

      <div
        @click="openAllClass"
        class="xiala"
      >
        <!-- <van-icon
          v-show="!oopupFlag"
          name="arrow-down"
        /> -->
        <span>全部</span>
        <van-icon
          v-show="oopupFlag"
          name="arrow-up"
        />
      </div>
    </div>
     <van-swipe :autoplay="3000">
      <van-swipe-item
        @click="onSearch"
      >
        <!-- <img :src="image" /> -->
        <img
          src="../../assets/pt/0311.png"
          alt=""
        >
      </van-swipe-item>
       <van-swipe-item
        @click="onSearch1"
      >
        <!-- <img :src="image" /> -->
        <img
          src="../../assets/pt/0314.jpg"
          alt=""
        >
      </van-swipe-item>
      <van-swipe-item
        @click="onSearch2"
      >
        <!-- <img :src="image" /> -->
        <img
          src="../../assets/pt/x2.jpg"
          alt=""
        >
      </van-swipe-item>
    </van-swipe>
    <div class="tgou">
      <ul class="clearfix">
        <li class="fl">
          <img src="../../assets/pt/04.png" alt="">
          <p>超级工厂</p>
        </li>
        <li class="fl">
          <img src="../../assets/pt/05.png" alt="">
          <p>定制宝</p>
        </li><li class="fl">
          <img src="../../assets/pt/06.png" alt="">
          <p>金牌制造榜</p>
        </li><li class="fl">
          <img src="../../assets/pt/07.png" alt="">
          <p>咨询客服</p>
        </li>
      </ul>
      <div class="goog clearfix">
        <div class="g1 fl">
          <img src="../../assets/pt/08.png" alt="">
          <img src="../../assets/pt/09.png" alt="">
          <img src="../../assets/pt/10.png" alt="">
        </div>
         <div class="g1 fl g2">
          <img src="../../assets/pt/12.png" alt="">
          <div class="g2n">
          <img src="../../assets/pt/11-1.png" alt="">
          <img src="../../assets/pt/11-2.png" alt="">
          <img src="../../assets/pt/11-3.png" alt="">
          <img src="../../assets/pt/11-4.png" alt="">
          </div>
         
        </div>
      </div>
      <div class="zt">
          <img src="../../assets/pt/13.png" alt="">
        <ul class="clearfix">
          <li>
            <img src="../../assets/pt/14.png" alt="">
            
          </li>
          <li>
            <img src="../../assets/pt/15.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/16.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/17.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/18.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/19.png" alt="">
            
          </li><li  @click="go">
            <img src="../../assets/pt/20.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/21.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/22.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/23.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/24.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/25.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/26.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/27.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/28.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/29.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/30.png" alt="">
            
          </li><li>
            <img src="../../assets/pt/31.png" alt="">
            
          </li>
        </ul>
      </div>
      <div class="bb">
        <ul class="clearfix">
          <li>
            <img src="../../assets/pt/36.png" alt="">
          </li>
          <li>
            <img src="../../assets/pt/37.png" alt="">
          </li><li>
            <img src="../../assets/pt/38.png" alt="">
          </li><li>
            <img src="../../assets/pt/39.png" alt="">
          </li>
        </ul>
      </div>
    </div>
    <div class="di">
    <div class="dis">
      <ul class="claearfix">
        <li @click="goc">
          {{ctxt}}
          <van-icon name="arrow-down" />
        </li>
         <li v-for="v in 2" :key="v">
          {{'生态板'}}
        </li>
      </ul>
    </div>
    <div class="over">
      <div class="content">
        <ul >
          <li
            class="clearfix"
         @click="onSearch"
          
          >
            <img
              src="../../assets/pt/kda.png"
              alt=""
            >
            <p class="name">山东凯大新型材料科技有限公司</p>
            <p class="price">钢结构楼板 / 隔声板 / 硅藻阻燃板  </p>
            <div class="jin">
              <img src="../../assets/pt/40-1.png" alt="">
            </div>
            <p class="jies">山东凯大新型材料科技有限公司是一家集研发、生产、销售为一体的国家高新技术企业</p>
            <div class="jian">
              <img src="../../assets/pt/40.png" alt="">
            </div>
            <div class="can">
              <img src="../../assets/pt/01.jpg" alt="">
              <img src="../../assets/pt/02.jpg" alt="">
              <img src="../../assets/pt/03.jpg" alt="">

            </div>
          </li>
          <li
            class="clearfix"
         @click="onSearch1"
          
          >
            <img
              src="../../assets/pt/ka11.png"
              alt=""
            >
            <p class="name">众旺未来（上海）建材科技有限公司</p>
            <p class="price">Aismy装配式高隔声隔墙系统  </p>
            <div class="jin">
              <img src="../../assets/pt/40-1.png" alt="">
            </div>
            <p class="jies">聚焦内装工业化产品研发制造，赋能装配式内装企业系统营销与施工。打造全国装配基地服务站。</p>
            <div class="jian">
              <img src="../../assets/pt/40.png" alt="">
            </div>
            <div class="can">
              <img src="../../assets/pt/ka12.jpg" alt="">
              <img src="../../assets/pt/ka13.jpg" alt="">
              <img src="../../assets/pt/ka14.jpg" alt="">

            </div>
          </li>
          <li
            class="clearfix"
         @click="onSearch2"
          
          >
            <img
              src="../../assets/pt/x1.jpg"
              alt=""
            >
            <p class="name">上海倾一宸</p>
            <p class="price">建筑吊顶材料批发 </p>
            <div class="jin">
              <img src="../../assets/pt/40-1.png" alt="">
            </div>
            <p class="jies">上海倾一宸建筑材料有限公司扎根上海，辐射全
              国的建筑材料批发商</p>
            <div class="jian">
              <img src="../../assets/pt/40.png" alt="">
            </div>
            <div class="can">
              <img src="https://shop.huokongjian.net/upload/advandbanner/2025-05/20250519/609bc72715ddbe733b88207384e72806.png" alt="">
              <img src="https://shop.huokongjian.net/upload/advandbanner/2025-05/20250519/e667c248ae1522877371edf3b51b1bc1.png" alt="">
              <img src="https://shop.huokongjian.net/upload/advandbanner/2025-05/20250519/cfaf13bcb045d14fdd002a044c1c7ff3.png" alt="">

            </div>
          </li>
        </ul>
      </div>
    </div>
    </div>
 <van-popup v-model="showPicker" round position="bottom">
  <van-picker
    show-toolbar
    :columns="columns"
    @cancel="showPicker = false"
    @confirm="onConfirm"
  />
</van-popup>
<van-popup style="height:80%" v-model="alls" position="bottom" >
  <div class="tan">
<div class="heard">
  全部类目
  <span @click="close" ><van-icon name="cross" /></span>
</div>
<div class="con" v-for="v1 in oneclass" :key="v1.id">
  <div class="cont">{{v1.name}}</div>
  <div class="conc">
    <ul class="clearfix" >
      <li @click="onSearch" v-for="v in twoclass" :key="v.id">
        <img :src="v.thumb" alt="">
        <p>{{v.name}}</p>
      </li>
    </ul>
  </div>
</div>
</div>
</van-popup>
<div v-show="$store.state.qdf" class="qd">
  <img src="../../assets/pt/qd.jpg" alt="">
</div>
    </div>
</template>
<script>
import Vue from 'vue'
import { Search,Swipe, SwipeItem,Picker,Popup, Tab, Tabs, Icon, Tabbar, TabbarItem, Lazyload, Toast,NavBar } from 'vant'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Lazyload).use(Swipe)
  .use(SwipeItem).use(Picker).use(Popup).use(NavBar)
 
export default {
   created(){
   setTimeout(()=>{
    console.log(12)
    this.$store.state.qdf=false
   },3000)
      this.axios.get("categoryList", { params: { store_id: this.$route.query.sd } }).then(res => {
      this.oneclass = res.data.data.list
      this.twoclass = res.data.data.son_list
      console.log(res)

    }).catch(ref => {
      // console.log(res)
    })
  },
    data() {
        return{
       oopupFlag:false ,
       statusNav:0,
       ctxt:'所属地',
     showPicker:false,
        columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      alls:false,
      oneclass:[],
      twoclass:[],
      qdf:true,
      value:''
        }
    },
    methods:{
        onSearch(){
          // console.log(this.value)
          this.$router.push('/gongx')
        },
         onSearch1(){
          // console.log(this.value)
          this.$router.push('/gongd')
      },
      onSearch2(){
          // console.log(this.value)
          this.$router.push('/gongs')
        },
        openAllClass () {
      
      //  this.alls=true
      },
      onClickLeft () {
      this.$router.go(-1)
    },
     addClass(){

        },
      goi(){
          this.$router.push('/')
        },
        go(){
          this.$router.push('gongl')

        },
      goc(){
        this.showPicker=true
      },
      onConfirm(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.ctxt=value
      this.showPicker=false
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast('取消');
    },
    close(){
      this.alls=false
    },
    }
}
</script>
<style lang="less" scoped>
.van-search__content--round{
  border: 1px solid #ff5500;
}
.qd{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: #fff001;
  z-index: 999;
  img{
    // height: 100%;
  }
}
.top{
    padding-top: 2rem;
    position: relative;
    img{
        width: 22%;
        margin: 0 auto;
    }
    .top-r{
        width: 0.85rem;
        height: 0.85rem;
        position: absolute;
        right: 0.5rem;
        bottom: 0rem;
        img{
            width: 100%;
        }
    }
}
.nav-wrap {
//   position: fixed;
//   top: 1.27rem;
position: relative;
  padding-left: 0.266667rem;
//   left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 999;
  height: 1.3rem;
  background-color: #fff;
  // background-color: #f99;

  .nav-wrap-all {
    width: 100%;
    height: 0.653333rem;
    padding-left: 0.2rem;
    // color: #fff;
    font-size: 0.45rem;
  }

  .xiala {
    width: 17%;
    height: 0.65rem;
    display: flex;
    justify-content: center;
    background-color: #fff;
    // background-color: #f99;

    color: #a3a3a1;
    font-size: 0.55rem;
    align-items: center;
    span{
      font-size: 0.4rem;
    }
    // transition: 0.3s;
  }

  .nav {
    width: 93%;
    overflow-x: auto;
    background-color: #fff;
    // background-color: #f99;

    ul {
      display: flex;
      white-space: nowrap;
justify-content :start;

      li {
        position: relative;
        padding: 0.1rem 0.3rem;
        span {
        //   color: #fff;
          font-size: 0.4rem;
          font-weight: 700;
        }
      }
      .li1{
        padding-left: 0.2rem;
      }
      .aimg{
  padding-left:0.3rem ;
  // padding-top: 0.1rem;
  // flex-grow:1;
  position: relative;
  bottom: 0.11rem;
  // margin: 0.1rem;
  img{
  width: 1.5rem;

// height: 110%;
  }
}
      .hot {
        width: 0.8rem;
        height: 0.7rem;
        position: absolute;
        top: -0.1rem;
        right: -0.35rem;
        color: #ffff00;
        font-size: 0.4rem;
      }

      li.active {
        // background-color: #c4af78;
        // border-radius: 0.2rem;
        color: #ff5500;
      }
      
    }
    .s1{
justify-content : flex-start;

    }
  }
}
.nav-oopup {
  position: fixed;
  width: 100%;
  top: 2.5rem;
  height: 0;
  overflow: hidden;
  transition: height 0.3s;
  z-index: 20;
//   color: #fff;
  background-color:#fff;
  // background-color: #f99;

  ul {
    display: flex;
    padding-top: 0.3rem;
    flex-wrap: wrap;

    li {
      width: 30%;
      height: 0.5rem;
      line-height: 0.5rem;
      text-align: center;
      margin-left: 0.27rem;
      border-radius: 0.1rem;
      margin-bottom: 0.3rem;
      box-sizing: border-box;
      span{
      font-size: 0.4rem;

      }
    }

    .active {
      width: 30%;
      background-color: #c4af78;
      border-radius: 0.4rem;
      padding: -1px 0.2rem;
    }
  }
}
.search{
  margin-top: 0.1rem;
  position: relative;
  .se{
    position: absolute;
    top: 0.3rem;
    right: 0.35rem;
    background-color: #ff5500;
    border-radius: 0.5rem;
    padding: 0rem 0.4rem;
    // padding-top: 0.2rem;
    // line-height: 1.5rem;
    height: 0.95rem;
    width: 1.5rem;
    padding-top: 0.1rem;
    padding-left: 0.5rem;
    font-size: 0.5rem;
    color: #fff;
  }
}
.tgou{
  width: 100%;
  background-color:  #fafcfb;
  height: 21.3rem;
  padding: 0.2rem;
  li{
    margin: 0.12rem;
    width: 22%;
    text-align: center;
    img{
      width: 70%;
      margin: 0 auto;
    }
    p{
      font-size: 0.4rem;
      padding-top: 0.2rem;
      color: #6d6d6d;
    }
  }
  .goog{
   padding-top: 0.3rem;
    .g1{
    background-color: #fff;
    border-radius: 0.2rem;
    padding: 0.2rem;
    box-shadow: 1px 1px 1px 1px #a8a7a7;
    margin-right: 0.4rem;
      width: 47%;
      img{
        width: 100%;
      }
    }
    .g2{
      margin-right: 0;
      .g2n{
        // width: 48%;
        padding-top: 0.38rem;
        img{
          width: 50%;
        float: left;

        }
      }
    }
  }
  .zt{
    padding-top: 0.4rem;
    img{
      width: 80%;
    }
    ul{
      li{
        float: left;
        width: 25%;
        margin: 0;
        padding: 0.2rem 0;
        img{
          // width: 97%;
          width: 100%;
          height: 2.1rem;
        }
      }
    }
  }
  .bb{
    li{
      width: 22%;
      float: left;
      img{
        width: 100%;
      }
    }
  }
}
.di{
  padding: 0.2rem;
  padding-top: 4rem;
  .dis{
    overflow-x: auto;
    ul{
    display: flex;
    white-space: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: start;

    }
    li{
      // width: 2.5rem;
      float: left;
      margin-right: 0.2rem;
      border-radius: 0.2rem;
      text-align: center;
      font-size: 0.35rem;
      padding: 0.2rem;
      background-color: #eeeeee;
    }
  }
  .over{
    .content {
    flex: 1;
    
    ul {
      li {
        // float: left;
        // width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        // margin-left: 0.1rem;
        margin: 0.2rem 0 0.5rem 0rem;
        img {
          width: 3.666667rem;
          float: left;
          margin-right: 0.2rem;
        }
        p{
         
        }
        .price {
          height: 0.6rem;
          line-height: 0.6rem;
          font-size: 0.3rem;
          // color: #a22d2b;
          font-weight: 600;
          span{
            // text-align: right;
            padding-left: 1rem;
            color:#a8a5a5;
          }
        }
        .name {
          font-size: 0.4rem;
          color: #333;
          font-weight: 600;
            display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .jin{
          // width: 1.5rem;
          height: 0.7rem;
          img{
            width: 2.5rem;
          }
        }
        .jies{
           display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .jian{
          padding-top: 0.4rem;
          height: 1.2rem;

          img{
            width: 0.4rem;
          }
        }
        .can{
          img{
            float: left;
            width: 1.75rem;
            margin-right: 0.05rem;
          }
        }
      }
    }
  }
  }
}
.tan{
  // height: 12rem;
  padding: 0.2rem;
  .heard{
    font-size: 0.4rem;
    font-weight: 500;
    text-align: center;
    position: relative;
    span{
      position: absolute;
      right: 0.1rem;
      // padding-left: 2rem;
      font-size: 0.5rem;
    }
  }
  .con{
    padding-top: 0.5rem;
    .cont{
      font-size: 0.38rem;
      font-weight: 600;
    }
    .conc{
      li{
        float: left;
        width: 23%;
        text-align: center;
        padding: 0.2rem;
        margin: 0.05rem;
        img{
          width: 100%;
          margin: 0 auto;
        }
        p{
          color: #808282;
          padding-top: 0.2rem;
        }
      }
    }
  }
}
</style>